export default __webpack_public_path__ + "static/media/login.1aa06fa8.jpg";